export default __webpack_public_path__ + "static/media/solar2.ef908dce.jpg";